import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { right } from '@popperjs/core';
import {
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { MyOrganizationFacade, getRolesAndPermission } from '@piqet-angular/data';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ProductGroupsDataGridService {
  productsGroupPayload: any;
  event: any;
  Access: any;

  editProductGroupData = new Subject<[any, any, any]>();
  productGroupObservable$ = this.editProductGroupData.asObservable();
  deleteProductGroupData = new Subject<[any, any, any]>();
  productGroupDeleteObservable$ = this.deleteProductGroupData.asObservable();

  constructor(private swalService: SwalService, private route: Router) {}

  getProductGroupsDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'position',
      headerName: 'position',
      field: 'position',
      hide: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Label',
      field: 'name',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.innerHTML = `${cellValue}`;
        !params.data.isSystem && (cellElement.style.cursor = 'pointer');
        !params.data.isSystem && (cellElement.style.textDecoration = 'underline');
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          const activeRoute = this.route.url.split('/')[2];
          !params.data.isSystem &&
            this.editProductGroupData.next([
              params.data.id,
              'Review product group detail',
              activeRoute,
            ]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'OrganizationName',
      headerName: 'Organization',
      field: 'organizationName',
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'IsPublic',
      headerName: 'Public',
      field: 'isPublic',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      minWidth: grid_widths_map.sm_column_xxm,
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      cellRendererParams: {
        showEdit: this.isAccess() ? this.isAccess().isEdit : true,
        showDelete: this.isAccess() ? this.isAccess().isDelete : true,
        value: 'manageProductGroups',
        deleteData: (data: any, customName: any) => {
          this.deleteproductGroupConfirmation(
            data.id,
            '/MyOrganizationProductGroup/DeleteMyOrganizationProductGroup?id',
            customName
          );
        },
        editData: (data: any, pathName: any) => {
          this.editProductGroupData.next([data.id, 'Review product group detail', pathName]);
        },
      },
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });

    return colDef;
  }

  isAccess = () => {
    return getRolesAndPermission(
      rolesModuleName.myOrganizationProductGroup,
      mainModuleName.myOrganizationModule
    );
  };

  deleteproductGroupConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteProductGroupData.next([data, customType, pathName]);
      } else {
      }
    });
  }

  getProductGroupsPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getProductGroupsDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'actions');

    return (this.productsGroupPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'position',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }
}
